const _excluded = ["className", "children", "onClick", "badge", "selected", "fullWidthOnMobile"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Typography } from 'onboarding-components';
import styles from './index.module.styl';
type TileButtonBase = {
  selected?: boolean;
  fullWidthOnMobile?: boolean;
  badge?: React.ReactNode;
};
type ButtonProps = TileButtonBase & React.ButtonHTMLAttributes<HTMLButtonElement>;
export const TileButton = forwardRef(function TileButtonBase(_ref: ButtonProps, ref) {
  let {
      className,
      children,
      onClick,
      badge,
      selected = false,
      fullWidthOnMobile = false
    }: ButtonProps = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return <button ref={ref as unknown as React.Ref<HTMLButtonElement>} className={clsx(styles.bubbleOption, className, {
    [styles.optionFullWidth]: fullWidthOnMobile,
    [styles.selected]: selected
  })} onClick={onClick} {...rest}>
      <Typography weight='bold' variant='captionSm' className={styles.text}>
        {children}
      </Typography>
      {badge}
    </button>;
});